import { useStore } from "../../stores/StoreContext";
import { GlossariesService } from "../LogicServices/GlossaryService";

export function useGlossaryService(): GlossariesService {
  const storeContext = useStore();
  return new GlossariesService(storeContext);
}
